import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import './styles.css';
import UserRegister from './UserRegister';
import UserList from './UserList';
import UserPermission from '../../components/UserPermission';
import MultiManual from '../../components/Manual/MultiManual';
import { Typography } from '@mui/material';

const classes = {
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%'
  }
}

export default function CadastroDeUsuario() {
  const history = useNavigate();

  /* Permissão do usuário no sistema */
  let userPermission = UserPermission();

  useEffect(() => {
    if (userPermission !== 'admin') {
      toast.error("Seu usuário não possuí privilégios para acessar essa página!");
      history("/search");
    }
  }, [userPermission, history]);

  if (userPermission !== 'admin') {
    return null;
  } else {
    return (

      <div className="register-container">

        <div id='teste-manual'>
          <UserRegister />
        </div>

        <hr></hr>


        <div
          style={{
            backgroundColor: '#F5F5F5',
            borderRadius: 10,
            padding: 20
          }}
          id='user-list'
        >
          <Typography variant="h5" align="center" style={{
            margin: 8,
            color: '#103168',
            fontWeight: 600,
            marginBottom: 30,
          }}>
            Listagem de usuários
          </Typography>
          <div
            style={classes.message}
          >
            Abaixo será listado os usuários cadastrados no sistema.
            É possível editar ou excluir um usuário selecionando uma das opções a direita da tabela.
          </div>

          <div>
            <UserList />
          </div>
        </div>



        <MultiManual
          components={[
            {
              id: 'form-user-register',
              message: 'Você pode preencher este formulário com os dados de um novo usuário e conceder-lhe um nível de acesso',
              rect: { height: 20, top: -20 },
              padding: 20
            },
            {
              id: 'buttons-user-register-confirm',
              message: 'Para concluir o cadastro clique aqui',
              rect: { top: 17 },
              padding: 20
            },
            {
              id: 'buttons-user-register-clear',
              message: 'Ou pode limpar os campos preenchidos para retornarem aos valores padrões para preencher novamente',
              rect: { top: 17 },
              padding: 20
            },
            {
              id: 'user-list',
              message: 'Esta é a lista de usuários cadastrados no sistema',
              rect: { height: 20, top: -20 },
              padding: 20
            } 
          ]}
        /> 
      </div >
    );
  }
}